import React, { useState } from 'react';
import { formatDateTime } from '../../utils/functions';
import CommonTable from '../global/table';
import CommonCardView from '../global/cardView';
import NoRecordFound from '../global/noRecordFound';
import EnhancedAffiliatesCustomersCardView from './enhancedAffiliatesCustomersCardView';
import CommonDrawer from '../global/drawer';
import EnhancedAffiliatesCustomerDetails from './enhancedAffiliatesCustomerDetails';

const EnhancedAffiliatesCustomersList = ({
    isLoading,
    customers,
    sort,
    setSort,
    viewType
}) => {
    const [customerDetails, setCustomerDetails] = useState({
        show: false,
        data: null
    });

    // Columns Configuration
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            sortType: "Name",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            sortType: "Email",
        },
        {
            title: "Phone",
            dataIndex: "phone",
            key: "phone",
            sortType: "Phone",
        },
        {
            title: "Registered At",
            dataIndex: "registeredAt",
            key: "registeredAt",
            sortType: "Registered At",
        },
        {
            title: "Plan / Price",
            dataIndex: "planPrice",
            key: "planPrice",
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
        },
    ];

    // Data Mapping - Match API response structure
    const data = Array.isArray(customers) && customers.length > 0
        ? customers.map((item) => ({
            key: item._id,
            id: item._id,
            name: item?.User?.[0]?.name || "-",
            email: item?.User?.[0]?.email || "-",
            phone: item?.User?.[0]?.phone || "-",
            registeredAt: formatDateTime(item?.User?.[0]?.createdAt),
            planPrice: `${item?.Plan?.[0]?.planName || "-"} / $${item?.Plan?.[0]?.planPrice || "-"}`,
            commission: `$${item?.commissionAmount || 0}`,
            originalData: item,
        }))
        : [];

    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={(record) => setCustomerDetails({ show: true, data: record.originalData })}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedAffiliatesCustomersCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => setCustomerDetails({ show: true, data: record.originalData })}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No customers found." />
            )}
            {
                customerDetails.show && (
                    <CommonDrawer
                        open={customerDetails.show}
                        setOpen={() => setCustomerDetails({ show: false, data: null })}
                        title="Customer Details"
                        width={"1000px"}
                        children={
                            <EnhancedAffiliatesCustomerDetails
                                customerDetail={customerDetails.data}
                                setShowDetail={(show) => setCustomerDetails(prev => ({ ...prev, show }))}
                            />
                        }
                    />
                )
            }
        </>
    );
};

export default EnhancedAffiliatesCustomersList;
